var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomizationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8100_5391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2143 1.9989H12.6786V2.39868H12.9201V4.32033H10.8558V2.39868H11.0973V1.9989H8.16287V2.39868H8.40054V4.32033H6.33628V2.39868H6.57778V1.9989H3.78518C3.33093 1.9989 2.96484 2.36778 2.96484 2.8255V13.1734C2.96484 13.6311 3.33093 14 3.78518 14H15.2143C15.6647 14 16.0347 13.6311 16.0347 13.1734V2.8255C16.0347 2.37164 15.6666 1.9989 15.2143 1.9989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.665086 3.13257H2.58176V12.8683H0.665086C0.297085 12.8683 0 12.5689 0 12.1981V3.80273C0 3.43192 0.297085 3.13257 0.665086 3.13257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 3.13257H16.418V12.8683H18.3346C18.7026 12.8683 18.9997 12.5689 18.9997 12.1981V3.80273C18.9997 3.43192 18.7026 3.13257 18.3346 3.13257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71875 2.62464H6.96025V1.23796C6.96025 0.554283 7.51225 0 8.18884 0H11.0696C11.7481 0 12.2982 0.556215 12.2982 1.23796V2.62464H12.5397V4.01517H11.2383V2.62464H11.4798V1.23796C11.4798 1.01007 11.2958 0.824665 11.0696 0.824665H8.18884C7.96267 0.824665 7.77867 1.01007 7.77867 1.23796V2.62464H8.02017V4.01517H6.71875V2.62464Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8100_5391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizationIcon);
export default __webpack_public_path__ + "static/media/customization-icon.b06094379db1cd33995520017ff2ac0a.svg";
export { ForwardRef as ReactComponent };